import { gql } from "@apollo/client";

export const LIST_HOMEOWNER_CLIENTS_FOR_REQUEST = gql`
  query ListHomeownerClientsForRequest($first: Int, $after: String, $search: String) {
    listHomeowners(first: $first, after: $after, search: $search) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          userId
          firstName
          lastName
          email
          phoneNumber
          clientProfile {
            id
            ownerType
          }
        }
      }
    }
  }
`;

export const GET_HOMEOWNER_FOR_REQUEST = gql`
  query GetHomeownerForRequest($id: String!) {
    homeowner(id: $id) {
      id
      userId
      firstName
      lastName
      email
      phoneNumber
      clientProfile {
        id
        ownerType
      }
      addresses {
        id
        address
        city
        state
        formattedAddress
        placeId
      }
    }
  }
`;

export const REQUEST_CATEGORIES = gql`
  query RequestCategories($excludeSystemKeys: [CategorySystemKey!]) {
    categories(excludeSystemKeys: $excludeSystemKeys) {
      id
      name
      systemKey
      isVisible
    }
  }
`;

export const ADMIN_CREATE_HOMEOWNER_REQUEST = gql`
  mutation AdminCreateHomeownerRequest($data: AdminCreateHomeownerRequestInput!) {
    adminCreateHomeownerRequest(data: $data) {
      id
      order {
        id
        orderCode
      }
    }
  }
`;

export const LIST_ORGANIZATION_CLIENTS_FOR_REQUEST = gql`
  query ListOrganizationClientsForRequest($first: Int, $after: String, $search: String) {
    organizationClientProfiles(first: $first, after: $after, search: $search) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        cursor
        node {
          id
          organization {
            id
            name
          }
          clientProfile {
            id
            ownerType
          }
          contactName
          contactEmail
          contactPhoneNumber
          billingName
          billingAddress {
            id
            address
            city
            state
            formattedAddress
          }
        }
      }
    }
  }
`;

export const ADMIN_ORGANIZATION_REQUEST_CONTEXT = gql`
  query AdminOrganizationRequestContext($clientProfileId: String!) {
    adminOrganizationRequestContext(clientProfileId: $clientProfileId) {
      organizationClientProfile {
        id
        organization {
          id
          name
        }
        clientProfile {
          id
          ownerType
        }
        contactName
        contactEmail
        contactPhoneNumber
        billingName
        billingAddress {
          id
          address
          city
          state
          formattedAddress
        }
      }
      facilities {
        id
        name
        address {
          id
          address
          city
          state
          formattedAddress
        }
        contacts {
          id
          name
          phoneNumber
          email
        }
      }
    }
  }
`;

export const ADMIN_CREATE_ORGANIZATION_ONE_TIME_REQUEST = gql`
  mutation AdminCreateOrganizationOneTimeRequest(
    $data: AdminCreateOrganizationOneTimeRequestInput!
  ) {
    adminCreateOrganizationOneTimeRequest(data: $data) {
      id
      order {
        id
        orderCode
      }
    }
  }
`;
